export let InputControls = {
    message: {
        required: {
            value: 'Field is required'
        },
    },

    minimum: {
        message: {
            value: 'Please select  one Annual option.'
        }
    },

    horizon: {
        message: {
            value: 'At least one option required'
        }
    },

    signature: {
        required: {
            value: 'Please provide a valid signature'
        }
    },

    login: {
        email: {
            type: 'email',
            label: 'Enter email',
            value: 'Email'
        },
        password: {
            type: 'password',
            label: 'Enter password',
            value: 'Password'
        }
    },

    personalDetail: {
        name: {
            value: 'Name'
        },
        image: {
            type: 'text',
            label: 'image',
            value: 'Image'
        },
        description: {
            type: 'text',
            label: 'description',
            value: 'Description'
        }
    },
}